import {RecordForm} from '../forms/RecordForm';


import {usePhase} from '../hooks/usePhase.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {useNavigate, useParams} from "react-router-dom";
import {Phase} from "../types.ts";


export const AddPage = () => {

    // The enclosing route is /playbooks/:id/phases/add — useParams().id is the playbookId.
    const {id: playbookId} = useParams();

    const navigate = useNavigate();
    const onCancel = () => {
        navigate(`/playbooks/${playbookId}`);
    }

    const {
        record,
        createRecord,
    } = usePhase();

    const seededRecord = {
        ...(record ?? {}),
        ...(playbookId ? {playbookId} : {}),
    } as Phase;

    return (
        <FormPageLayout
            title='Add Phase'
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm record={seededRecord} handleSubmit={createRecord} handleCancel={onCancel}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
